import React, { useEffect, useRef, useState, useCallback } from 'react';
import { useParams } from 'react-router-dom';
import { Container, Row, Col, Label, Input, Spinner, Button, Tooltip } from 'reactstrap';
import { uniqueId } from 'lodash';
import PropTypes from 'prop-types';
import DatePicker from 'react-datepicker';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faInfoCircle, faImages, faCamera, faArrowLeft } from '@fortawesome/free-solid-svg-icons';
import moment from 'moment';
import Lightbox from 'lightbox-react';
import { isMobile, MobileView } from 'react-device-detect';
import { useSelector, useDispatch } from 'react-redux';
import Translate, { t, numStr } from '../common/Translate';
import getAaa from '../../services/SearchVehicle/getAaa';
import getVehicleByVin from '../../services/SearchVehicle/getVehicleByVin';
import greyCradReader from '../../services/SearchVehicle/greyCradReader';
import clockBlue from '../../assets/img/clock-blue.svg';
import { datesFormat, decodeVinCountry, regexRegistration as regexRegRule } from '../../config';
import { Auth, recordActions } from '../../config/configuration/react';
import { formatEntryStocksDays } from '../../Store/helpers/pricing';
import { calendarLang } from '../../language-context';
import logo_noa from '../../assets/img/logo_noa-07.svg';
import imageLoading from '../../services/Image/imageLoading';

const FormRegVin = (props) => {
  const {
    mode,
    setSelectMode,
    setVehicle,
    className,
    entryStockValue,
    getEntryStockDate,
    setVersions,
    setImage,
    image = null,
    histovecInformation,
    setHistovecInformation,
    setPictureSuccess,
    pictureSuccess,
    setManuelSearchVinDecoding,
  } = props;
  const { recordId } = useParams();
  const dispatch = useDispatch();
  const [registration, setRegistration] = useState('');
  const [mileage, setMileage] = useState(null);
  const [vin, setVin] = useState('');
  const [entryDateRelease, setEntryDateRelease] = useState('');
  const [error, setError] = useState(false);
  const [isLoading, setisLoading] = useState(false);
  const [unknown, setUnknown] = useState(false);
  const country = Auth.country();
  const appLang = Auth.preferredLanguage();
  const entryStockOption = useSelector((state) => state.reduxRecords.data[recordId])?.entryStockOption;
  const originId = useSelector((state) => state?.reduxRecords?.data[recordId]?.record?.originId);
  const language = useSelector((state) => state?.reduxRecords?.data[recordId]?.record?.language);
  const recordCountryId = useSelector((state) => state?.reduxRecords?.data[recordId]?.record?.countryId);
  const isUkFile = recordCountryId === 16;
  const [tooltipOpen, setTooltipOpen] = useState(false);
  const regexRegistration = new RegExp(regexRegRule[country] ? regexRegRule[country] : regexRegRule.default);
  const isMounted = useRef(false);
  const regexVIN = new RegExp('^[a-zA-Z0-9]{17}$');
  const vinOrReg = decodeVinCountry.includes(country) ? 'vin' : 'reg';
  const [popedUp, setPopup] = useState(false);
  const [pictureErrors, setPictureErrors] = useState({});
  const [loadingImage, setLoadingImage] = useState(false);
  const [histovecInfo, setHistovecInfo] = useState(histovecInformation);
  const { sourceInfos } = useSelector((state) => state?.reduxRecords?.data[recordId]);
  const histovecStatus = useSelector((state) => state.reduxRecords.data[recordId])?.histovecStatus || {};
  const enableRegistrationCard =
    ['fr', 'es'].includes(country.toLowerCase()) && sourceInfos?.sourceGroupData?.enableRegistrationCarReader;
  const [registrationMethod, setRegistrationMethod] = useState(!enableRegistrationCard ? 'licensePlate' : null);
  const [sourceInfoLoading, setSourceInfoLoading] = useState(false);
  const [tooltipOpenFirst, setTooltipOpenFirst] = useState(false);

  const formatDataRegistrationCard = (data) => {
    const newFormat = {};
    newFormat.owner = {};
    newFormat.owner.formula = data?.formula?.value;
    newFormat.brand = data?.brand?.value;
    newFormat.model = data?.model?.value;
    newFormat.registration = data?.registration?.value;
    setRegistration(data?.registration?.value || null);
    newFormat.first_registration_date = data?.first_registration_date?.value
      ? moment(data?.first_registration_date?.value).toDate()
      : null;
    newFormat.registration_date = data?.registration_date?.value
      ? moment(data?.registration_date?.value).toDate()
      : null;
    if (data?.ownerType === 'professional') {
      newFormat.owner.companyName = data?.company?.value;
      newFormat.owner.companySiren = data?.siren?.value;
    } else {
      newFormat.owner.privateName = data?.firstName?.value;
      newFormat.owner.privateLastName = data?.lastName?.value;
    }
    newFormat.ownerType = data?.ownerType;
    return newFormat;
  };

  const changeHistovecInfo = useCallback(
    (e) => {
      const { value, name } = e.target;
      const [key, subKey] = name.includes('.') ? name.split('.') : [name];
      setHistovecInformation((prevInfo) => {
        return {
          ...prevInfo,
          [key]: { ...(prevInfo[key] || {}), [subKey]: value },
        };
      });

      setHistovecInfo((prevInfo) => {
        return {
          ...prevInfo,
          [key]: { ...(prevInfo[key] || {}), [subKey]: value },
        };
      });
    },
    [setHistovecInformation, setHistovecInfo],
  );

  const disableCtaValidate = () => {
    if (
      (country === 'NL' && [null, undefined, ''].includes(mileage)) ||
      (vinOrReg === 'vin' && [null, ''].includes(vin)) ||
      (vin !== '' && [null, ''].includes(entryDateRelease)) ||
      (vinOrReg === 'reg' && [null, ''].includes(registration)) ||
      entryStockValue === 'select' ||
      (country.toLowerCase() === 'fr' &&
        ((registrationMethod === 'registrationCard' && !histovecInfo?.owner?.formula) ||
          (registrationMethod === 'registrationCard' &&
            histovecInfo?.ownerType === 'particular' &&
            (!histovecInfo?.owner?.privateName || !histovecInfo?.owner?.privateLastName)) ||
          (registrationMethod === 'registrationCard' &&
            histovecInfo?.ownerType === 'professional' &&
            !histovecInfo?.owner?.companyName)))
    )
      return true;
    return false;
  };
  const getSourceDetails = async () => {
    setSourceInfoLoading(true);
    await dispatch(recordActions.getSourceInfo(recordId));
    setSourceInfoLoading(false);
  };
  useEffect(() => {
    dispatch(recordActions.getEntryStockOption(recordId));
    if (!sourceInfos && ['fr', 'es'].includes(country.toLowerCase())) getSourceDetails();
    return () => {
      isMounted.current = true;
    };
  }, [recordId]);
  useEffect(() => setRegistrationMethod(!enableRegistrationCard ? 'licensePlate' : null), [enableRegistrationCard]);
  useEffect(() => {
    setRegistration('');
    setMileage(null);
    setError(false);
    setUnknown(false);
    setPictureErrors((errors) => ({ ...errors, errorHistovecInfoSave: null }));
    if (registrationMethod === 'registrationCard') setRegistration(histovecInfo?.registration || null);
  }, [registrationMethod]);

  const openInfoBull = () => {
    setTooltipOpen(!tooltipOpen);
  };
  const handleIdentificationChange = (e) => {
    setError(false);
    setUnknown(false);
    let { value } = e.target;
    const { name } = e.target;
    if (name !== 'entryDateRelease') value = value.replace(/[^a-zA-Z^0-9]/g, '');
    switch (name) {
      case 'registration':
        if (!regexRegistration.test(value) && value !== '') {
          setRegistration('');
          setError('registration_dont_match');
          break;
        }
        setRegistration(value);
        break;
      case 'vin':
        if (!regexVIN.test(value) && value !== '') {
          setVin('');
          setError('vin_dont_match');
          break;
        }
        setVin(value);
        break;
      case 'entryDateRelease':
        setEntryDateRelease(value);
        break;
      case 'mileage':
        value = value.replace(/[^0-9]/g, '');
        if (value.length > 6) return;
        setMileage(value);
        break;
      default:
        break;
    }
  };

  const retriveInfoHistovec = async () => {
    if (histovecStatus?.id) return true;
    try {
      await dispatch(
        recordActions.retriveHistovecInfo(recordId, {
          ...histovecInfo?.owner,
          privateFormula: histovecInfo.ownerType === 'particular' ? histovecInfo.owner.formula : null,
          companyFormula: histovecInfo.ownerType === 'professional' ? histovecInfo.owner.formula : null,
          registration,
        }),
      );
      setPictureErrors((errors) => ({ ...errors, errorHistovecInfoSave: null }));
      return true;
    } catch (e) {
      setPictureErrors((errors) => ({ ...errors, errorHistovecInfoSave: 'SaveHistovecInfoFailedTryAgain' }));
      return false;
    }
  };
  const handleStockInfoChange = () => {
    switch (originId) {
      case 10:
        return t('entryStockDaysInfoNrm');
      case 11:
        return t('entryStockDaysInfoNrm');
      case 12:
        return t('entryStockDaysInfoNrmStandAlone');
      case 13:
        return t('entryStockDaysInfoNrmStandAlone');
      case 14:
        return t('entryStockDaysInfoNrmStandAlone');
      default:
        return t('entryStockDaysInfo');
    }
  };

  const identify = async (selectedMode) => {
    setSelectMode(selectedMode);
    setisLoading(true);
    let data = {};
    setManuelSearchVinDecoding({});
    try {
      if (selectedMode === 'registrationCard') {
        let save = true;
        if (['fr'].includes(country.toLowerCase())) save = await retriveInfoHistovec(histovecInfo);
        if (save) identify('registration');
        return;
      }
      if (selectedMode === 'registration') {
        [data] = await getAaa(registration, language, mileage);
      } else if (selectedMode === 'vin') {
        const entryDateReleaseValue = entryDateRelease !== null ? moment(entryDateRelease).format('YYYY-MM-DD') : null;
        [data] = await getVehicleByVin(vin, country, entryDateReleaseValue, language);
      }
      // if (entryStockValue >= 0 && entryStockDate)
      //   await dispatch(recordActions.putSupervisorInfos(recordId, { entryStockValue, entryStockDate }));
      if (data.status === true || data.status === 'OK' || data.status === 'OK2') {
        // format data depending on aaa or dat
        if (data.doors) data.doorId = data.doors;
        if (data.engine) data.engineId = data.engine;
        if (data.gearboxId) data.gearId = data.gearboxId;
        if (data.gearboxName) data.gearName = data.gearboxName;
        data.mileage = mileage;
        data.entryDateRelease = entryDateRelease;
        if (isMounted.current) return;
        await setVehicle({ ...data, fromReg: true, versionType: selectedMode });
        await setVersions(data.versions || []);
        // props.setAaa(data);
      } else {
        setUnknown(true);
      }
    } catch (e) {
      setError(e.message);
    } finally {
      if (!isMounted.current) {
        setisLoading(false);
      }
    }
  };
  const changeRegistrationMethod = (method) => {
    setRegistrationMethod(method);
  };

  const handleAddImage = async (e) => {
    e.persist();
    setLoadingImage(true);
    setUnknown(false);
    setPictureErrors((errors) => ({ ...errors, pictureUploadErrors: null }));
    const img = e.target.files[0];
    const imageURL = await imageLoading(img);
    setImage(imageURL);
    try {
      const formData = new FormData();
      formData.append('greyCardPicture', img);
      const result = await greyCradReader(formData, recordId);
      if (result?.success) {
        setHistovecInformation(formatDataRegistrationCard(result?.data));
        setHistovecInfo(formatDataRegistrationCard(result?.data));
        setPictureSuccess(result?.success);
      } else {
        setPictureErrors((errors) => ({ ...errors, pictureUploadErrors: result?.errors }));
        setPictureSuccess(result?.success);
      }
    } catch (err) {
      setPictureErrors((errors) => ({ ...errors, pictureUploadErrors: ['picture_error'] }));
      setPictureSuccess(false);
    } finally {
      setLoadingImage(false);
    }
  };
  const RegistrationMethodLabel = () => {
    switch (registrationMethod) {
      case 'registrationCard':
        return (
          <Row className="align-items-center">
            <Col xs="10" lg="3">
              <span
                className="mr-2"
                style={{ cursor: 'pointer' }}
                onClick={() => changeRegistrationMethod(null)}
                aria-hidden="true"
              >
                <FontAwesomeIcon size="1x" icon={faArrowLeft} />
              </span>
              {t('scanYourRegistrationCard')}
            </Col>
            <Col xs="2" lg="3">
              <img src={logo_noa} alt="" />
            </Col>
          </Row>
        );
      case null:
        if (!enableRegistrationCard) return null;
        return (
          <>
            {t('AUTOMATIC_IDENTIFICATION')}
            <FontAwesomeIcon
              icon={faInfoCircle}
              size="1x"
              id="toolTipTrustIndexInformationBox"
              className="info-icon ml-4"
            />
            <Tooltip
              placement="bottom"
              isOpen={tooltipOpenFirst}
              target="toolTipTrustIndexInformationBox"
              toggle={() => !isMobile && setTooltipOpenFirst((prev) => !prev)}
            >
              {t('automaticIdentificationTooltip')}
            </Tooltip>
          </>
        );
      default:
        if (!enableRegistrationCard) return null;
        return (
          <span
            className="mr-2"
            style={{ cursor: 'pointer' }}
            onClick={() => changeRegistrationMethod(null)}
            aria-hidden="true"
          >
            <FontAwesomeIcon size="1x" icon={faArrowLeft} />
          </span>
        );
    }
  };

  const togglePopup = () => {
    setPopup(!popedUp);
  };

  if (sourceInfoLoading)
    return (
      <div className="loader-full-screen main">
        <Spinner />
      </div>
    );

  return (
    <Container fluid className={`${className} from-regvin`}>
      {popedUp && <Lightbox mainSrc={image} onCloseRequest={togglePopup} />}
      <h1 className="h5 text-primary">
        <img src={clockBlue} className="align-top mr-2" alt="" />
        {t('vehicle_identification')}
      </h1>
      <hr className="primary" />
      <Label for={mode} className="alternate my-4">
        {RegistrationMethodLabel()}
      </Label>
      {!['registrationCard', 'licensePlate'].includes(registrationMethod) && enableRegistrationCard && (
        <Row className="flex-column align-items-start">
          <Col xs="12" lg="5" className="my-2 w-100">
            <button
              type="button"
              className="btn btn-block  mb-1 custom-registration-card-btn py-1 px-1"
              onClick={() => changeRegistrationMethod('registrationCard')}
            >
              <img src={logo_noa} alt="" />
              <span className="ml-2">{t('scanYourRegistrationCard')}</span>
            </button>
          </Col>
          <Col xs="1" className="my-2 w-100">
            <Label className="alternate"> {t('OR')}</Label>
          </Col>
          <Col xs="12" lg="5" className="my-2">
            <button
              type="button"
              className="btn btn-block btn-primary mb-1 py-2 px-1"
              onClick={() => changeRegistrationMethod('licensePlate')}
            >
              {t('enterYourLicensePlate')}
            </button>
          </Col>
        </Row>
      )}
      {['registrationCard'].includes(registrationMethod) && enableRegistrationCard && (
        <>
          {image && (
            <div className={`position-relative h-25 ${isMobile ? 'w-100' : 'w-25'}`}>
              <img
                src={image}
                className="w-100 custom-img-card-registration my-2"
                alt=""
                aria-hidden="true"
                onClick={togglePopup}
              />
              {loadingImage && (
                <div className="position-absolute w-100 h-100 top-0 start-0 d-flex align-items-center justify-content-center upload-image-card-loadind">
                  <Spinner color="dark" size="sm" />
                </div>
              )}
            </div>
          )}
          <div className={`d-flex alignt-item-center ${isMobile && 'justify-content-center'} mb-3`}>
            <Row className="align-item-center">
              <Col className={`text-center ${image && isMobile && 'd-none'}`}>
                {image && !isMobile && !loadingImage && (
                  <label htmlFor="upload_gallery">
                    <div className="btn btn-link pl-0">{t('changeImage')}</div>
                  </label>
                )}
                <label htmlFor="upload_gallery" className={`button-camera circle ${image && 'd-none'}`}>
                  <FontAwesomeIcon icon={faImages} />
                  <input
                    type="file"
                    id="upload_gallery"
                    accept=".png, .jpg, .jpeg"
                    onChange={handleAddImage}
                    data-cy="upload_gallery"
                  />
                </label>
                {!image && <Translate code="gallery" />}
              </Col>
              <MobileView className={`${image && 'w-100'}`}>
                <Col className="text-center">
                  {image && !loadingImage && (
                    <label htmlFor="upload_camera" className="text-center">
                      <div className="btn btn-link pl-0">{t('redo')}</div>
                    </label>
                  )}
                  <label htmlFor="upload_camera" className={`button-camera circle ${image && 'd-none'}`}>
                    <FontAwesomeIcon icon={faCamera} />
                    <input
                      type="file"
                      id="upload_camera"
                      accept=".png, .jpg, .jpeg"
                      capture
                      onChange={handleAddImage}
                      data-cy="upload_camera"
                      className={image && 'd-none'}
                    />
                  </label>
                  {!image && <Translate code="camera" />}
                </Col>
              </MobileView>
              {pictureErrors?.pictureUploadErrors?.length > 0 && (
                <Col xs="12" lg="12">
                  {pictureErrors?.pictureUploadErrors
                    ?.filter((err) => err)
                    .map((err, index) => (
                      <div key={uniqueId(index)} className="text-danger text-start">
                        {err}
                      </div>
                    ))}
                </Col>
              )}
            </Row>
          </div>
        </>
      )}
      {['registrationCard'].includes(registrationMethod) && pictureSuccess && enableRegistrationCard && (
        <>
          <Row>
            <Col xs={12} md={6} lg={4}>
              <Label for={mode} className="alternate">
                {t('DATERELEASE')}
              </Label>
              <DatePicker
                className="alternate icon-calendar"
                name="firstRegistrationDate"
                id="firstRegistrationDate"
                selected={
                  histovecInfo?.first_registration_date ? moment(histovecInfo?.first_registration_date).toDate() : ''
                }
                locale={calendarLang[appLang]}
                dateFormat={appLang === 'DE' ? datesFormat[appLang] : datesFormat.default}
                placeholderText={t('long_date_placeholder')}
                autoComplete="off"
              />
            </Col>
          </Row>
          <Row>
            <Col xs={12} md={6} lg={4}>
              <Label for={mode} className="alternate">
                {t('DATEGRAYCARD')}
              </Label>
              <DatePicker
                className="alternate icon-calendar"
                name="entryDateRelease"
                id="entryDateRelease"
                selected={histovecInfo?.registration_date ? moment(histovecInfo?.registration_date).toDate() : ''}
                locale={calendarLang[appLang]}
                dateFormat={appLang === 'DE' ? datesFormat[appLang] : datesFormat.default}
                placeholderText={t('long_date_placeholder')}
                autoComplete="off"
              />
            </Col>
          </Row>
          {(histovecInfo?.ownerType === 'particular' || country.toLowerCase() === 'es') && (
            <>
              <Row>
                <Col xs={12} md={6} lg={4}>
                  <Label className="alternate" for="privateName">
                    {t('Name')}
                  </Label>
                  <Input
                    placeholder="firstName"
                    type="text"
                    name="owner.privateName"
                    id="privateName"
                    value={histovecInfo?.owner?.privateName || ''}
                    onChange={changeHistovecInfo}
                    className="alternate"
                  />
                </Col>
              </Row>
              <Row>
                <Col xs={12} md={6} lg={4}>
                  <Label className="alternate" for="privateLastName">
                    {t('LastName')}
                  </Label>
                  <Input
                    placeholder="lastName"
                    type="text"
                    name="owner.privateLastName"
                    id="privateLastName"
                    value={histovecInfo?.owner?.privateLastName || ''}
                    onChange={changeHistovecInfo}
                    className="alternate"
                  />
                </Col>
              </Row>
            </>
          )}
          {histovecInfo?.ownerType === 'professional' && (
            <>
              <Row>
                <Col xs={12} md={6} lg={4}>
                  <Label className="alternate" for="companyName">
                    {t('Company')}
                  </Label>
                  <Input
                    placeholder="company"
                    type="text"
                    name="owner.companyName"
                    id="companyName"
                    value={histovecInfo?.owner?.companyName || ''}
                    onChange={changeHistovecInfo}
                    className="alternate"
                  />
                </Col>
              </Row>
              <Row>
                <Col xs={12} md={6} lg={4}>
                  <Label className="alternate" for="companySiren">
                    {t('Siren')}
                  </Label>
                  <Input
                    placeholder="siren"
                    type="text"
                    name="owner.companySiren"
                    id="companySiren"
                    value={histovecInfo?.owner?.companySiren || ''}
                    onChange={changeHistovecInfo}
                    className="alternate"
                  />
                </Col>
              </Row>
            </>
          )}
          {country.toLowerCase() !== 'es' && (
            <Row>
              <Col xs={12} md={6} lg={4}>
                <Label className="alternate" for="formula">
                  {t('formula')}
                </Label>
                <Input
                  placeholder="formula"
                  type="text"
                  name="owner.formula"
                  id="formula"
                  value={histovecInfo?.owner?.formula || ''}
                  onChange={changeHistovecInfo}
                  className="alternate"
                />
              </Col>
            </Row>
          )}
        </>
      )}
      {vinOrReg === 'reg' && ['licensePlate'].includes(registrationMethod) && (
        <>
          <Row>
            <Col>
              <Label for={mode} className="alternate">
                {t('registration')}
              </Label>
            </Col>
          </Row>

          <Row>
            <Col xs={12} md={6} lg={4}>
              <Input
                placeholder={t('registration_placeholder')}
                name="registration"
                id="registration"
                defaultValue={registration}
                className="alternate"
                onChange={handleIdentificationChange}
                // onKeyPress={(event) => {
                //   if (event.key === 'Enter') {
                //     identify('registration');
                //   }
                // }}
              />
            </Col>
          </Row>
        </>
      )}
      {['registrationCard'].includes(registrationMethod) && pictureSuccess && (
        <>
          <Row>
            <Col>
              <Label for={mode} className="alternate">
                {t('registration')}
              </Label>
            </Col>
          </Row>

          <Row>
            <Col xs={12} md={6} lg={4}>
              <Input
                placeholder={t('registration_placeholder')}
                name="registration"
                id="registration"
                value={histovecInfo?.registration}
                className="alternate"
                onChange={handleIdentificationChange}
              />
            </Col>
          </Row>
        </>
      )}

      {vinOrReg === 'vin' && registrationMethod === 'licensePlate' && (
        <>
          <Row>
            <Col>
              <Label for={mode} className="alternate">
                {t('vin')}
              </Label>
            </Col>
          </Row>
          <Row>
            <Col xs={12} md={6} lg={4}>
              <Input
                placeholder="XXXXZ03AH55354925"
                name="vin"
                id="vin"
                defaultValue={vin}
                className="alternate"
                onChange={handleIdentificationChange}
                onKeyPress={(event) => {
                  if (event.key === 'Enter') {
                    identify('vin');
                  }
                }}
              />
            </Col>
          </Row>
          <Row>
            <Col>
              <Label for={mode} className="alternate">
                {t('registrationDate')}
              </Label>
            </Col>
          </Row>
          <Row>
            <Col xs={12} md={6} lg={4}>
              <DatePicker
                className="alternate icon-calendar"
                name="entryDateRelease"
                id="entryDateRelease"
                onChange={(e) => {
                  handleIdentificationChange({ target: { value: e, name: 'entryDateRelease' } });
                }}
                selected={entryDateRelease ? moment(entryDateRelease).toDate() : ''}
                locale={calendarLang[appLang]}
                dateFormat={appLang === 'DE' ? datesFormat[appLang] : datesFormat.default}
                placeholderText={t('long_date_placeholder')}
                autoComplete="off"
                showMonthDropdown
                showYearDropdown
                yearDropdownItemNumber={10}
                scrollableYearDropdown
                popperModifiers={{
                  flip: {
                    behavior: ['bottom'], // don't allow it to flip to be above
                  },
                  preventOverflow: {
                    enabled: false, // tell it not to try to stay within the view (this prevents the popper from covering the element you clicked)
                  },
                  hide: {
                    enabled: false, // turn off since needs preventOverflow to be enabled
                  },
                }}
                filterDate={(date) => {
                  return moment() > date;
                }}
              />
            </Col>
          </Row>
        </>
      )}
      {(['licensePlate'].includes(registrationMethod) ||
        (['registrationCard'].includes(registrationMethod) && pictureSuccess)) && (
        <>
          <Row>
            <Col xs={12} md={6} lg={4}>
              <Label className="alternate" for="mileage">
                {t(isUkFile ? 'mileageInMiles' : 'mileage')}
              </Label>
              <Input
                placeholder="90 000"
                type="text"
                name="mileage"
                id="mileage"
                value={(mileage && numStr(mileage)) || ''}
                className="alternate"
                onChange={handleIdentificationChange}
              />
            </Col>
          </Row>
          <Row>
            <Col xs={12} md={6} lg={4}>
              <Label className="alternate" for="entryStockDays">
                {t('entryStockDays')}
                <>
                  <FontAwesomeIcon
                    icon={faInfoCircle}
                    size="1x"
                    id="entryStock"
                    className="info-icon ml-2"
                    onClick={openInfoBull}
                  />
                  <Tooltip
                    placement="bottom"
                    isOpen={tooltipOpen}
                    target="entryStock"
                    toggle={!isMobile && openInfoBull}
                  >
                    {handleStockInfoChange()}
                  </Tooltip>
                </>
              </Label>
              <Input
                type="select"
                name="entryStockDays"
                id="entryStockDays"
                className="alternate"
                value={entryStockValue}
                onChange={(e) => getEntryStockDate(e.target.value)}
              >
                <option key="select" value="select">
                  {t('selectEntryStockDate')}
                </option>
                {entryStockOption &&
                  formatEntryStocksDays(entryStockOption).map((i, k) => (
                    <option key={i} value={k}>
                      {i}
                    </option>
                  ))}
              </Input>
            </Col>
          </Row>
        </>
      )}
      {(['licensePlate'].includes(registrationMethod) ||
        (['registrationCard'].includes(registrationMethod) && pictureSuccess)) && (
        <>
          <Row>
            <Col xs={12} md={6} lg={4}>
              {unknown === false && (
                <button
                  type="button"
                  data-test="identifyVehicle-btn"
                  className={`btn btn-block ${isLoading || disableCtaValidate() ? 'btn-4' : 'btn-1'}`}
                  disabled={
                    isLoading || disableCtaValidate() || (loadingImage && registrationMethod === 'registrationCard')
                  }
                  onClick={() => {
                    let identifier;
                    if (registrationMethod !== 'registrationCard') {
                      identifier = registration !== '' ? 'registration' : 'vin';
                    } else {
                      identifier = registration ? 'registrationCard' : 'vin';
                    }
                    identify(identifier);
                  }}
                >
                  {(isLoading && <Spinner color="light" size="sm" />) || <Translate code="identify_vehicle" />}
                </button>
              )}
              {unknown && (
                <Button color="success" block onClick={() => setVehicle({})}>
                  {t('create_new_inspection')}
                </Button>
              )}
            </Col>
          </Row>
          <Row>
            <Col xs={12} lg={4}>
              {error && (
                <p className="text-center text-md-left mt-2 mt-md-0 text-danger">
                  <Translate code={error} />
                </p>
              )}
              {unknown && <p className="text-center text-md-left mt-2 mt-md-0 text-danger">{t('unknow_vehicle')}</p>}
            </Col>
          </Row>
          {pictureErrors?.errorHistovecInfoSave && (
            <p className="text-center text-md-left mt-2 mt-md-0 text-danger">
              {t(pictureErrors?.errorHistovecInfoSave)}
            </p>
          )}
        </>
      )}
    </Container>
  );
};

FormRegVin.propTypes = {
  mode: PropTypes.string.isRequired,
  setSelectMode: PropTypes.func.isRequired,
  setVehicle: PropTypes.func.isRequired,
  className: PropTypes.string.isRequired,
  entryStockValue: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  getEntryStockDate: PropTypes.func.isRequired,
  setVersions: PropTypes.func.isRequired,
  setImage: PropTypes.func.isRequired,
  image: PropTypes.string,
  histovecInformation: PropTypes.shape().isRequired,
  setHistovecInformation: PropTypes.func.isRequired,
  setPictureSuccess: PropTypes.func.isRequired,
  pictureSuccess: PropTypes.bool.isRequired,
  setManuelSearchVinDecoding: PropTypes.func.isRequired,
};

FormRegVin.defaultProps = {
  image: null,
};

export default FormRegVin;
